/*
#############################################################################
# Copyright (c) 2022-2023 NVIDIA CORPORATION & AFFILIATES. All rights reserved.
#
# NVIDIA CORPORATION, its affiliates and licensors retain all intellectual
# property and proprietary rights in and to this material, related
# documentation and any modifications thereto. Any use, reproduction,
# disclosure or distribution of this material and related documentation
# without an express license agreement from NVIDIA CORPORATION or
# its affiliates is strictly prohibited.
###############################################################################
*/

import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";

const style = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginTop: "calc((100vh - 49px - 25px - 31.5vh - 32px)/2)",
  width: "100%",
};

function Error404() {
  const navigate = useNavigate();
  const handleGoback = () => {
    navigate(-1);
  };
  return (
    <Box sx={style}>
      Error — Page not found
      <Button onClick={handleGoback}>Go back</Button>
    </Box>
  );
}

export default Error404;
